<lms-breadcrumb [label]="'agents.create'"></lms-breadcrumb>
<lms-agent-editor (onSave)="onSave($event)">
  <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="cancel()" form-actions-before></gl-button>
</lms-agent-editor>
